/**
 * all.js
 * Written by: Alex Kasemir
 */
import { createSelector } from 'reselect';

/**
 * Description of the all selector
 *
 * @param {Object} state - The redux store to pull data from
 */
export const all = createSelector(
  [
    (state) => state.category.byId,
    (state) => state.category.allIds,
  ],
  (byId, allIds) => allIds
    .map((s) => byId[s])
    .sort((a, b) => {
      if (a.weight === b.weight) {
        if (a.name < b.name) { return -1; }
        if (a.name > b.name) { return 1; }
        return 0;
      }
      return b.weight - a.weight;
    }),
);


export default all;
